import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequest } from "@utils/http-util";
import { injectRpServiceId } from "@utils/parameter-injector";
import { VerificationServiceChangeRequestResponse } from "@idw-types/data/verification-service";

type RestoreVerificationServiceRequestResponse = {
    transferObject: VerificationServiceChangeRequestResponse;
};

export const restoreVerificationServiceRequest = async (
    verificationServiceId: string
): Promise<{ data: RestoreVerificationServiceRequestResponse; error: any }> => {
    const route = injectRpServiceId(apiRoutes.serviceConfiguration.rpServiceConfig.rpService.restore, verificationServiceId);

    const { data, error } = await handleRequest(RequestTypes.POST, route);
    return { data, error };
};